import React, { useContext, useEffect, useState, useMemo } from 'react';
import KpiDefinitionData from 'service/KpiDefinitionData';
import { FilterContext } from 'components/FilterBar/FilterProvider';
import CardContainer from 'components/redesign/CardContainer';
import type { KpiData } from 'components/redesign/KpiTile/types';
import KpiGrid from 'components/redesign/KpiGrid';
import KpiTile from 'components/redesign/KpiTile';
import {
  enabledBU,
  activeBU,
  buWithActiveCycles,
  buWithCompletedCycles,
  skusToBeDeleted,
  percentOfSkuReduction,
  revenueContributionByDeletedSkus,
} from '@v2/kpis/dtv/tpo/reachMetrics';
import { useDynamicGraphQLQuery } from '@hooks/useDynamicGraphQLQuery';

interface SummaryMetricsTPOValueCreationProps {
  title?: string;
}

const SummaryMetricsTPOValueCreation: React.FC<
  SummaryMetricsTPOValueCreationProps
> = ({ title }) => {
  const [overViewConfig, setOverviewConfig] = useState<KpiData[]>([]);

  const { selectedProduct, selectedFrequency, endUTCDate } =
    useContext(FilterContext);

  // When frequency is Monthly, pass year attribute with the year extracted from endDate
  const customFilters = useMemo(() => {
    if (selectedFrequency?.id === 'Monthly' && endUTCDate) {
      const year = new Date(endUTCDate).getUTCFullYear();
      return { year };
    }
    return {};
  }, [selectedFrequency, endUTCDate]);

  const { data, isLoading } = useDynamicGraphQLQuery(
    'getPOReachMetrics',
    customFilters
  );

  useEffect(() => {
    if (data?.getPOReachMetrics?.data && !isLoading) {
      const handlerData = {
        getPOReachMetrics: data.getPOReachMetrics.data,
      };

      const updatedOverviewConfig = [
        enabledBU.handler(handlerData),
        activeBU.handler(handlerData),
        buWithActiveCycles.handler(handlerData),
        buWithCompletedCycles.handler(handlerData),
        skusToBeDeleted.handler(handlerData),
        percentOfSkuReduction.handler(handlerData),
        revenueContributionByDeletedSkus.handler(handlerData),
      ];

      setOverviewConfig(updatedOverviewConfig);
    } else {
      setOverviewConfig([]);
    }
  }, [data, isLoading]);

  return (
    <CardContainer
      isLoading={isLoading}
      title={title}
      showInfoIcon={true}
      dataDefinitions={{
        sections:
          KpiDefinitionData[selectedProduct?.productId]?.valueCreation
            ?.reachMetrics ?? [],
      }}
      isAccordion={false}
    >
      <KpiGrid columnsDesktop={5} columnsTablet={3} columnsMobile={1}>
        {overViewConfig.map((item, index) => (
          <KpiTile key={index} data={item} />
        ))}
      </KpiGrid>
    </CardContainer>
  );
};

export default SummaryMetricsTPOValueCreation;
